import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const CLIENT_ACTIVITY_OPTIONS = [
  { key: 'active', value: 'Active' },
  { key: 'passive', value: 'Passive' },
]

const LeadDashboardUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  updateEntryMode, submitted, onSubmit, onCancelClick,
  originatorList, salesChannelList, loanAmountEditable,

  brandName, onBrandNameChange, brandNameError, setBrandNameError,
  accountNamePan, onAccountNamePanChange, accountNamePanError, setAccountNamePanError,
  accountId, onAccountIdChange, accountIdError, setAccountIdError,
  comments, onCommentsChange, commentsError, setCommentsError,
  manualLoanAmount, onManualLoanAmountChange, manualLoanAmountError, setManualLoanAmountError,
  poc, onPocChange, pocError, setPocError,
  designation, onDesignationChange, designationError, setDesignationError,
  phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
  email, onEmailChange, emailError, setEmailError,
  originatorUserId, onOriginatorUserIdChange, originatorUserIdError, setOriginatorUserIdError,
  channel, onChannelChange, channelError, setChannelError,
  followUpDate, onFollowUpDateChange, followUpDateError, setFollowUpDateError,
  clientActivity, onClientActivityChange, clientActivityError, setClientActivityError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update Lead'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateEntryMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <div className='ld_modal_scroll_body'>
    <div className='g_m_bottom_100'>
      <b>Editing: {brandName || accountNamePan || 'New entry'}</b>
    </div>

    <InputTextSF type='text' name='brandName' label='Brand Name'
      value={brandName} onChange={onBrandNameChange}
      error={brandNameError} setError={setBrandNameError}
    />
    <InputTextSF type='text' name='accountNamePan' label='Account Name (as on PAN)'
      value={accountNamePan} onChange={onAccountNamePanChange}
      error={accountNamePanError} setError={setAccountNamePanError}
    />
    <InputTextSF type='text' name='accountId' label='Account ID (paste once onboarded, to link)'
      value={accountId} onChange={onAccountIdChange}
      error={accountIdError} setError={setAccountIdError}
    />
    <InputTextAreaSF type='text' name='comments' label='Comments'
      value={comments} onChange={onCommentsChange}
      error={commentsError} setError={setCommentsError}
    />
        {
      loanAmountEditable &&
      <InputTextSF type='price' name='manualLoanAmount' label='Loan Amount'
        value={manualLoanAmount} onChange={onManualLoanAmountChange}
        error={manualLoanAmountError} setError={setManualLoanAmountError}
      />
    }
    {
      !loanAmountEditable &&
      <InputReadOnlyUI type='text' name='manualLoanAmount' label='Loan Amount'
        value={manualLoanAmount} onChange={() => {}}
      />
    }
    <InputTextSF type='text' name='poc' label='POC (Client End)'
      value={poc} onChange={onPocChange}
      error={pocError} setError={setPocError}
    />
    <InputTextSF type='text' name='designation' label='Designation'
      value={designation} onChange={onDesignationChange}
      error={designationError} setError={setDesignationError}
    />
    <InputTextSF type='text' name='phoneNumber' label='Phone No.'
      value={phoneNumber} onChange={onPhoneNumberChange}
      error={phoneNumberError} setError={setPhoneNumberError}
    />
    <InputTextSF type='text' name='email' label='E-Mail'
      value={email} onChange={onEmailChange}
      error={emailError} setError={setEmailError}
    />
    <InputSelectSF name='originatorUserId' label='Originator'
      value={originatorUserId} onChange={onOriginatorUserIdChange}
      error={originatorUserIdError} setError={setOriginatorUserIdError}
      optionList={originatorList}
    />
    <InputSelectSF name='channel' label='Channel'
      value={channel} onChange={onChannelChange}
      error={channelError} setError={setChannelError}
      optionList={salesChannelList}
    />
    <InputDateUI context={context} name='followUpDate' label='Follow Up (Date)'
      selectedDateISO={followUpDate} onChange={onFollowUpDateChange}
      error={followUpDateError}
    />
    <InputSelectSF name='clientActivity' label='Client Activity'
      value={clientActivity} onChange={onClientActivityChange}
      error={clientActivityError} setError={setClientActivityError}
      optionList={CLIENT_ACTIVITY_OPTIONS}
    />
    </div>
  </ModalFormUI>
export default LeadDashboardUpdateModalUI